export default __webpack_public_path__ + "static/media/pot2.6d7de541.svg";